export default __webpack_public_path__ + "static/media/img-virtual-building-3.5df72c8e.png";